<template>
    <v-card class="mb-12">
        <v-simple-table
            fixed-header
            height="700px"
            class="portal--table">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th v-for="header in headers" :key="header" v-html="header"></th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="(row, year) in columns[0]"
                    v-show="parseInt(row) >= 0"
                    :key="year"
                    :class="{ 'portal--table-row-selected': year == yearsFromPassingAway.personOne || row == yearsFromPassingAway.personTwo}">
                    <td v-for="(column, colIndex) in columns" :key="year + colIndex">
                        <span v-if="moneyFormatColumn[colIndex]">
                            {{ column[year] | money }}
                        </span>
                        <span v-else>
                            {{ column[year] }}
                        </span>

                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>

    </v-card>
</template>

<script>
export default {
    name: 'SipsTable',

    props: {
        headers: {
            type: Array,
            default: () => []
        },
        columns: {
            type: Array,
            default: () => []
        },
        yearsFromPassingAway: {
            type: Object,
            default: () => {
                return {
                    personOne: 0,
                    personTwo: 0
                }
            }
        },
        moneyFormatColumn: {
            type: Array,
            default: () => []
        }
    }
}
</script>


